import { MouseEvent, PropsWithChildren } from 'react';

import type { IButtonProps } from './schemas';

export function BasicButton({
  onClick,
  disabled = false,
  className,
  ariaLabel,
  children,
  ...restButtonProps
}: IButtonProps & PropsWithChildren) {
  const onClickHandler = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button"
      onClick={onClickHandler}
      disabled={disabled}
      className={className}
      aria-label={ariaLabel}
      {...restButtonProps}
    >
      {children}
    </button>
  );
}
